import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { clearAuthNotification as clearAuthNotificationAction } from '../../actions/auth';
import { socialSignUpUser as socialSignUpUserAction } from '../../actions/social';

import SocialSignupPage from './SocialSignupPage';

const _mapStateToProps = ({ authentication }) => ({
    locale: authentication.locale,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    socialSSOSettings: authentication.socialSSOSettings,
    authNotificationOptions: authentication.authNotificationOptions,
    linkedAccountSuccessUrl: authentication.linkedAccountSuccessUrl,
    disableRecaptcha3: authentication.disableRecaptcha3,
    usesNewStyles: authentication.featureFlags.launchAuthenticationRefactor,
});

const _mapDispatchToProps = {
    onSocialSignUpUser: socialSignUpUserAction,
    clearAuthNotification: clearAuthNotificationAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SocialSignupPage),
);
